export const ANALYTICS_ALL_STRING = '*';

export const AnalyticsMoneyType = {
  ALL: 'all_money',
  REAL: 'real_money',
} as const;

export const AnalyticsGamePromotionStatus = {
  NONE: 'none',
  PROMOTED: 'promoted',
} as const;
